<body>
<!-- ============================================================== -->
<!-- Preloader - style you can find in spinners.css -->
<!-- ============================================================== -->
<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<div id="main-wrapper">

  <div style="width: 100%; align-content: center; margin-top: 10%; margin-bottom: 10%">
    <div class="login-div">
      <mat-card>
        <!--<mat-progress-bar *ngIf="inProgres" mode="indeterminate"></mat-progress-bar><br>-->
        <mat-card-title style="display: inline;margin-left: 74px">Reimposta password</mat-card-title>
        <button style="display: inline; margin-left: 40%; font-size: 17px" mat-button>
          <a class="nav-link" href="/home">{{'login.button-home'|translate}}</a>
        </button>
        <br><br>
        <mat-form-field style="width: 80%; margin-left: 10%">
          <input type="password" matInput placeholder="{{'login.password-placeholder'|translate}}" [formControl]="password" value = "" required>
          <mat-error *ngIf="password.invalid">{{getPassworErrorMessage()}}</mat-error>
        </mat-form-field>
        <mat-form-field style="width: 80%; margin-left: 10%">
          <input type="password" matInput placeholder="Ripeti la password" [formControl]="passwordRepeat" value = "" required>
          <mat-error *ngIf="password.invalid">{{getPassworErrorMessage()}}</mat-error>
        </mat-form-field>
        <br><br>
        <button (keyup.enter)="setNewPassword()" (click)="setNewPassword()"
                style="width: 80%; margin-left: 10%; display: inline"
                class="btn btn-primary" type="button" [disabled]="inProgres">
          <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" *ngIf="inProgres"></span>
          Reimposta la password
        </button>
      </mat-card>
    </div>
  </div>

  <app-footer></app-footer>


</div>
<!-- ============================================================== -->
<!-- End Wrapper -->
<!-- ============================================================== -->
<!-- ============================================================== -->
<!-- All Jquery -->
<!-- ============================================================== -->

</body>



